<template>
  <div class="calendar-container" v-if="calendar">
    <h1>{{ calendar.title }}</h1>

    <h2>Calendar</h2>

    <p>
      The following calendar is a sample calendar showing the recommended minimum pace at which you should
      complete assignments in order to finish the course in a timely manner.
    </p>

    <table class="table table-bordered">
      <thead>
      <tr>
        <th scope="col">Week</th>
        <th scope="col">Topics</th>
        <th scope="col">Reading</th>
        <th scope="col">Assignment</th>
        <th scope="col">Quiz</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, rowId) in calendarData" :key="rowId">
        <td v-for="(cell, cellId) in row" :key="cellId" :rowspan="cell.span">
          <router-link :to="{name: cell.content.target, params: cell.content.params}"
                       v-html="cell.content.text"
                       v-if="cell.content && cell.content.type === 'route'"/>
          <a v-else-if="cell.content && cell.content.type === 'url'"
             :href="cell.content.target"
             v-html="cell.content.text"
             target="_blank"></a>
          <span v-else-if="cell.content && cell.content.type === 'text'"
                v-html="cell.content.text"></span>
          <span v-html="cell.content" v-else></span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="stylus" scoped>
  td:nth-child(2) {
    width 20%
  }
  td:nth-child(3) {
    width 30%
  }
</style>
<script>
import calendars from 'components/courses/calendar'

export default {
  name: 'Calendar',
  data () {
    return {
      courseId: null,
      calendar: null,
      calendarData: []
    }
  },
  watch: {
    '$route.params': {
      immediate: true,
      deep: true,
      handler: function (params) {
        this.courseId = params['courseId']
        if (this.courseId && this.courseId in calendars) {
          this.calendar = calendars[this.courseId]
          this.calendarData = this.transformCalendarData(calendars[this.courseId]['schedule'])
        } else {
          this.calendar = null
          this.calendarData = []
        }
      }
    }
  },
  methods: {
    readingParser: function (reading) {
      if (reading == null) return reading
      if (typeof reading === typeof '') return reading.replace('\n', '<br />')
      return {
        'type': reading['type'],
        'text': reading['title'].replace('\n', '<br />'),
        'target': reading['target']
      }
    },
    assignmentParser: function (assignment) {
      if (typeof assignment !== typeof {} || assignment == null) return assignment
      return {
        'type': 'route',
        'text': assignment['name'].replace('\n', '<br />'),
        'target': 'Assignment',
        'params': {
          'courseId': this.courseId,
          'assignmentId': assignment['template']
        },
        'meta': {
          'test': 1
        }
      }
    },
    quizParser: function (quiz) {
      if (typeof quiz !== typeof {} || quiz == null) return quiz
      return {
        'type': 'route',
        'text': quiz['name'],
        'target': 'Quiz',
        'params': {
          'courseId': this.courseId,
          'quizId': quiz['template']
        }
      }
    },
    transformCalendarData: function (calendar) {
      let result = []
      Object.keys(calendar).map(week => {
        const content = calendar[week]
        // Handle Missing Keys
        if (!('material' in content) || typeof content['material'] !== typeof []) content['material'] = []
        if (!('assignment' in content) || content['assignment'] == null) content['assignment'] = null
        if (!('quiz' in content) || content['quiz'] == null) content['quiz'] = null

        // Add a dummy material if none exists
        if (content['material'].length === 0) {
          content['material'].push({'topic': null, 'reading': null})
        }

        // Make rows
        const makeCell = function (content, span = 1) {
          return {'content': content, 'span': span}
        }
        for (let i = 0; i < content['material'].length; i += 1) {
          let row = []
          if (i === 0) {
            row.push(makeCell(week, content['material'].length))
          }
          if (i === 0 || content['material'][i]['topic'] !== '') {
            let j = i + 1
            for (; j < content['material'].length && content['material'][j]['topic'] === ''; j += 1) ;
            row.push(makeCell(content['material'][i]['topic'], j - i))
          }
          row.push(makeCell(this.readingParser(content['material'][i]['reading'])))
          if (i === 0) {
            row.push(makeCell(
              this.assignmentParser(content['assignment']),
              content['material'].length))
            row.push(makeCell(
              this.quizParser(content['quiz']),
              content['material'].length))
          }
          result.push(row)
        }
      })

      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/submodule/Calendar.vue